import { useTranslation } from "react-i18next";
import { CheckCircle } from "@phosphor-icons/react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const ITEMS = [1, 2, 3, 4, 5, 6, 7, 8] as const;

export function TrustChecklist() {
  const ref = useScrollReveal<HTMLElement>();
  const { t } = useTranslation();

  return (
    <section
      ref={ref}
      className="animate-on-scroll relative py-24 sm:py-32"
      style={{
        background:
          "linear-gradient(180deg, oklch(98% 0.012 84) 0%, oklch(96% 0.018 84) 100%)",
      }}
    >
      {/* corner ornaments */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-px"
        style={{ background: "var(--color-warm-border)" }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 bottom-0 h-px"
        style={{ background: "var(--color-warm-border)" }}
      />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-8">
          {/* Header column */}
          <div className="col-span-12 lg:col-span-5">
            <h2 className="font-heading text-3xl leading-[1.1] font-bold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
              {t("forCompaniesPage.trust.title")}
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-muted-foreground sm:text-lg">
              {t("forCompaniesPage.trust.subtitle")}
            </p>
          </div>

          {/* Checklist column */}
          <div className="col-span-12 lg:col-span-7">
            <ul className="grid grid-cols-1 gap-x-10 sm:grid-cols-2">
              {ITEMS.map((n) => (
                <li
                  key={n}
                  className="group relative flex items-start gap-4 border-b py-5 transition-colors hover:bg-white/40"
                  style={{ borderColor: "var(--color-warm-border)" }}
                >
                  <span
                    className="mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full transition-transform duration-300 group-hover:scale-110"
                    style={{
                      background: "var(--color-brand-bg-light)",
                      color: "var(--color-brand-dark)",
                    }}
                  >
                    <CheckCircle className="size-5" weight="duotone" />
                  </span>
                  <div className="flex-1">
                    <p className="text-sm leading-snug font-medium text-foreground sm:text-[15px]">
                      {t(`forCompaniesPage.trust.item${n}`)}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
